import $ from 'jquery';
import Cache from 'root/cache';
import UI from 'root/ui';
import Util from 'root/module/util';
import Svg_Icon from 'root/module/svg_icon';
import View from 'view/base';
import Modal from 'root/module/modal';

export default View.extend({
    className: 'feedback-csv-upload',

    first_row_header: true,

    is_uploading: false,
    csv_preview_data: null,

    column_total: 0,
    uploaded_total: 0,

    field_mapping: {
        title: {
            column: null,
            mandatory: true,
            text: 'Title',
            example: 'Dark Mode',
            key_word: ['title', 'summary']
        },
        description: {
            column: null,
            mandatory: true,
            text: 'Description',
            example: 'Be good to have dark mode in the app.',
            key_word: ['description', 'details']
        },
        status: {
            column: null,
            mandatory: false,
            text: 'Status',
            example: 'Open',
            key_word: ['status']
        },
        vote: {
            column: null,
            mandatory: false,
            text: 'Vote',
            example: '12',
            key_word: ['vote', 'score', 'like']
        },
        category: {
            column: null,
            mandatory: false,
            text: 'Category',
            example: 'Improvement, UI',
            key_word: ['tag', 'tags', 'category', 'categories']
        },
        priority: {
            column: null,
            mandatory: false,
            text: 'Priority',
            example: 'Neutral',
            key_word: ['priority']
        },
        date: {
            column: null,
            mandatory: false,
            text: 'Create date',
            example: '2022-06-05T22:39:05.461Z',
            key_word: ['date', 'time', 'created']
        },
        name: {
            column: null,
            mandatory: false,
            text: 'Reporter name',
            example: 'Joan Lisi',
            key_word: ['name', 'authorname']
        },
        email: {
            column: null,
            mandatory: false,
            text: 'Reporter email',
            example: 'joanjlisi@example.com',
            key_word: ['email', 'authoremail']
        },
        /*
        attachment: {
            column: null,
            mandatory: false,
            text: 'Attachment URL',
            example: 'https://www.example.com/report.pdf',
            key_word: ['attachment']
        },
        */
        screenshot: {
            column: null,
            mandatory: false,
            text: 'Screenshot URL',
            example: 'https://www.example.com/image.png',
            key_word: ['screenshot', 'image', 'imageurl', 'imageurls']
        }
    },

    events: {
        'click .file-select'      : 'onSelectFile',
        'click .go-back'          : 'onGoback',
        'click .first-row-toggle' : 'onToggleFirstRow',
        'click th li'             : 'onSelectField',
        'click .upload-download'  : 'onDownload',
        'click .import-submit'    : 'onSubmit',
        'dragenter .file-select'  : 'onDragEnter',
        'dragover .file-select'   : 'onDragOver',
        'dragleave .file-select'  : 'onDragLeave',
        'drop .file-select'       : 'onDropFile'
    },

    dom_handlers: {
        onGoback: function(e) {
            this.csv_preview_data = null;
            this.column_total = 0;
            this.data_count = 0;

            this.$el.find('.region-upload-step[data-step="1"]').show();
            this.$el.find('.region-upload-step[data-step="2"]').hide();
        },

        onToggleFirstRow: function(e) {
            this.first_row_header = !this.first_row_header;

            if (this.first_row_header) {
                this.$el.find('.first-row-toggle').addClass('switch-on').removeClass('switch-off');
                this.$el.find('tr:eq(1)').addClass('header');
            } else {
                this.$el.find('.first-row-toggle').addClass('switch-off').removeClass('switch-on');
                this.$el.find('tr:eq(1)').removeClass('header');
            }

            this.renderImportButton();
        },

        onSelectField: function(e) {
            var field_name = $(e.currentTarget).data('val');
            var column_num = $(e.currentTarget).parents('th:first').index();

            var field_name_reset = null;
            var column_num_reset = null;

            if (field_name === 'skip') {
                field_name_reset = this.getFieldByColumn(column_num);
            } else {
                // another column has the field selected already, reset it
                column_num_reset = this.field_mapping[field_name].column;
                field_name_reset = this.getFieldByColumn(column_num);

                this.field_mapping[field_name].column = column_num;
            }

            if (field_name_reset) {
                this.field_mapping[field_name_reset].column = null;
            }

            // re-render the selected th
            this.$el.find('thead th:eq(' + column_num + ')').html(this.getHeaderDropdown(column_num));

            // re-render the th to be reset
            if (column_num_reset !== null) {
                this.$el.find('thead th:eq(' + column_num_reset + ')').html(this.getHeaderDropdown(column_num_reset));
            }
        },

        onDragEnter: function(e) {
            e.preventDefault();
            this.$el.find('.file-select').addClass('drag-over');
        },

        onDragOver: function(e) {
            e.preventDefault();
            this.$el.find('.file-select').addClass('drag-over');
        },

        onDragLeave: function(e) {
            e.preventDefault();
            this.$el.find('.file-select').removeClass('drag-over');
        },

        onDropFile: function(e) {
            e.preventDefault();

            var files = e.originalEvent.target.files || e.originalEvent.dataTransfer.files;

            if (files.length > 1) {
                UI.error('Please upload one csv file.');
                return;
            }

            if (files.length === 0) {
                return;
            }

            if (files[0].type !== 'text/csv') {
                UI.error('Please select a .csv file.');
                return;
            }

            var error = Util.readFile(files[0], 10, (file_name, file_type, file_content) => {
                this.previewFile(file_name, file_type, file_content);
            });

            if (error !== true) {
                UI.error(error);
            }
        },

        onSelectFile: function(e) {
            if (this.is_uploading) {
                return;
            }

            Util.uploadFile(10, (error_msg, file_name, file_type, file_content) => {
                if (error_msg) {
                    UI.error(error_msg);
                } else {
                    this.previewFile(file_name, file_type, file_content);
                }
            }, ['text/csv']);
        },

        onDownload: function(e) {
            e.preventDefault();

            if (this.is_downloading) {
                return;
            }

            this.is_downloading = true;

            this.$el.find('.upload-download .fa-download').removeClass('fa-download').addClass('fa-spinner-third fa-spin');

            Cache.app.request({
                action: 'feedback/csvdownload',
                data: {
                    job_id: this.job_id
                },
                success: (response) => {
                    window.location = response.csv;
                },
                complete: () => {
                    this.is_downloading = false;

                    this.$el.find('.upload-download .fa-spinner-third').removeClass('fa-spinner-third fa-spin').addClass('fa-download');
                }
            });
        },

        onSubmit: function(e) {
            var missing_fields = [];
            var fields = {};

            Object.keys(this.field_mapping).forEach((key) => {
                if (this.field_mapping[key].mandatory && this.field_mapping[key].column === null) {
                    missing_fields.push(this.field_mapping[key].text);
                }

                if (this.field_mapping[key].column !== null) {
                    fields[key] = this.field_mapping[key].column;
                }
            });

            if (missing_fields.length) {
                this.$el.find('.missing-fields').text('Missing fields: ' + missing_fields.join(', ')).show();
                return;
            }

            this.$el.find('.missing-fields').hide();

            var import_num = this.first_row_header ? this.data_count - 1 : this.data_count;

            Modal.confirm('Are you sure you want to import ' + import_num + ' idea' + (import_num === 1 ? '' : 's') + ' to your ideas portal?', () => {
                this.$el.find('.csv-upload-mask').show();
                this.$el.find('.csv-upload-progress').show();

                this.$el.find('.csv-upload-progress .header').text('Uploading ' + import_num + ' idea' + (import_num === 1 ? '' : 's') + '...');

                Cache.app.request({
                    action: 'feedback/csvupload',
                    data: {
                        fields            : fields,
                        file_name         : this.file_name,
                        file_content      : this.file_content,
                        include_first_row : this.first_row_header ? false : true
                    },
                    success: (response) => {
                        this.job_id = response.id;

                        // the csv import job has been created
                        // now let's start processing it
                        this.uploaded_total = 0;
                        this.queueUpload(this.job_id);
                    }
                });
            }, this, 'Yes, import');
        }
    },

    initialize: function() {
        this.field_mapping.status.example = Cache.workflow.at(0).get('name');
    },

    previewFile: function(file_name, file_type, file_content) {
        this.is_uploading = true;
        this.file_name    = file_name;
        this.file_content = file_content;

        this.$el.find('.uploading').show();
        this.$el.find('.upload-error').hide();
        this.$el.find('.missing-fields').hide();

        Cache.app.request({
            action: 'feedback/csvpreview',
            data: {
                file_name: file_name,
                file_content: file_content
            },
            success: (response) => {
                var limit_trial = 1000;
                var limit_hard  = 4000;

                if (Cache.account.get('is_trial') && response.count > limit_trial) {
                    this.$el.find('.upload-error').text('CSV file is too large. Please upload up to ' + limit_trial + ' records at a time.').show();
                    return;
                }

                if (response.count > limit_hard) {
                    this.$el.find('.upload-error').text('CSV file is too large. Please upload up to ' + limit_hard + ' records at a time.').show();
                    return;
                }

                if (response.count === 0) {
                    this.$el.find('.upload-error').text('Upload error: the csv file seems to be empty or corrupted.').show();
                } else {
                    this.csv_preview_data = response.data;

                    this.$el.find('.region-upload-step[data-step="1"]').hide();
                    this.$el.find('.region-upload-step[data-step="2"]').show();

                    this.data_count = response.count;

                    this.renderImportButton();

                    this.detectHeader(true);
                    this.renderCsvPreview();
                }
            },
            complete: () => {
                this.is_uploading = false;
                this.$el.find('.uploading').hide();
            }
        });
    },

    queueUpload: function(job_id) {
        Cache.app.request({
            action: 'feedback/csvuploadQueue',
            data: {
                job_id: job_id
            },
            success: (response) => {
                this.uploaded_total += response.uploaded;

                var import_num = this.first_row_header ? this.data_count - 1 : this.data_count;

                var percent;
                if (response.has_more) {
                    percent = Math.round(this.uploaded_total / import_num * 100) + '%';

                    this.queueUpload(job_id);
                } else {
                    percent = '100%';
                }

                this.$el.find('.upload-percent').text(percent);
                this.$el.find('.meteor-success span').width(percent);

                if (percent === '100%') {
                    this.$el.find('.csv-upload-progress .header').text('Upload has been completed');
                    this.$el.find('.csv-upload-progress .icon').html(Svg_Icon.checkmark);

                    this.$el.find('.open-portal').show();

                    if (response.error_count) {
                        this.$el.find('.upload-download').show();
                        this.$el.find('.upload-percent').html(
                            '<i class="fa-solid fa-circle-check text-success"></i> Uploaded: ' + (this.uploaded_total - response.error_count) +
                            '<i class="fa-solid fa-circle-xmark text-danger margin-left-12"></i> Failed: ' + response.error_count
                        );
                    }
                }
            },
            error: () => {
                UI.error('Error occurred, please try it again.');
            }
        });
    },

    getFieldByColumn: function(column_num) {
        var result = '';

        Object.keys(this.field_mapping).forEach((key) => {
            if (this.field_mapping[key].column === column_num) {
                result = key;
            }
        });

        return result;
    },

    detectHeader: function(reset) {
        if (!this.first_row_header) {
            return;
        }

        if (!this.csv_preview_data || !this.csv_preview_data.length) {
            return;
        }

        if (reset) {
            Object.keys(this.field_mapping).forEach((key) => {
                this.field_mapping[key].column = null;
            });
        }

        var header_row = this.csv_preview_data[0];

        header_row.forEach((header_value, column_num) => {
            header_value = header_value.toLowerCase().trim();

            Object.keys(this.field_mapping).forEach((key) => {
                if (this.field_mapping[key].column !== null) {
                    return;
                }

                if (this.field_mapping[key].key_word.indexOf(header_value) !== -1) {
                    this.field_mapping[key].column = column_num;
                }
            });
        });
    },

    validateCell: function(field_name, cell_val) {
        var is_valid = true;

        switch (field_name) {
            case 'screenshot':
                cell_val.split(',').forEach((url) => {
                    if (!Util.isImage(url.trim())) {
                        is_valid = false;
                    }
                });
                break;
            case 'date':
                // 2022-06-28T22:39:05.461Z
                // 2022-06-28 22:40
                // 06/28/2022 22:40
                // 2022/06/28 22:40
                is_valid = Date.parse(cell_val) ? true : false;
                break;
            case 'email':
                is_valid = Util.isValidEmail(cell_val);
                break;
            case 'priority':
                is_valid = ['urgent', 'high', 'neutral', 'low'].indexOf(cell_val) !== -1;
                break;
            case 'vote':
                is_valid = Util.isNumeric(cell_val);
                break;
        }

        return is_valid;
    },

    renderCsvPreview: function() {
        this.column_total = 0;

        var header  = '';
        var body    = '';

        this.csv_preview_data.forEach((row_data, index) => {
            var first_row = index === 0;

            body += '<tr' + (first_row && this.first_row_header ? ' class="header"' : '') + '>';

            row_data.forEach((column_data) => {
                body += '<td' + (column_data.length > 300 ? ' title="'  + (Util.htmlEntities(column_data)) + '"' : '') + '>' + Util.htmlEntities(Util.trim(column_data, 300)) + '</td>';
            });

            this.column_total = Math.max(this.column_total, row_data.length);

            body += '</tr>';
        });

        header += '<tr>';

        for (var i = 0; i < this.column_total; i++) {
            header += '<th>' + this.getHeaderDropdown(i) + '</th>';
        }

        header += '</tr>';

        var content = '<table><thead>' + header + '</thead><tbody>' + body + '</tbody></table>';

        this.$el.find('.region-csv-preview').html(content);
    },

    getHeaderDropdown: function(column_num) {
        var field_name    = this.getFieldByColumn(column_num);
        var field_text    = field_name ? this.field_mapping[field_name].text : '';
        var field_example = field_name ? this.field_mapping[field_name].example : '';

        var dropdown_options = '';
        var invalid_count = 0;

        Object.keys(this.field_mapping).forEach((key) => {
            dropdown_options += '<li data-val="' + key + '"' + (field_name === key ? ' class="selected"' : '') + '>' + this.field_mapping[key].text + '</li>';
        });

        dropdown_options += '<li data-val="skip"' + (field_name === '' ? ' class="selected"' : '') + '>Skip</li>';

        // format validation
        if (['date', 'priority', 'email', 'vote', 'screenshot'].indexOf(field_name) !== -1) {
            this.csv_preview_data.forEach((row_data, row_num) => {
                if (this.first_row_header && row_num === 0) {
                    return;
                }

                if (row_data[column_num] === '') {
                    return;
                }


                var is_valid = this.validateCell(field_name, row_data[column_num]);
                if (!is_valid) {
                    invalid_count++;
                }
            });
        }

        var header =
        '<div>' +
            '<div class="dropdown-container">' +
                '<div class="button-dropdown button-dropdown-full button-dropdown-left">' +
                    '<button type="button" class="dropdown-select dropdown-select-medium font-weight-medium">' +
                        (field_text || '<span class="text-info">Skip this column</span>') +
                    '</button>' +
                    '<div>' +
                        '<ul class="dropdown dropdown-select dropdown-long">' +
                            dropdown_options +
                        '</ul>' +
                    '</div>' +
                '</div>' +
            '</div>' +
            (invalid_count ?
            '<span class="invalid-cell">' +
                '<i class="fa-solid fa-circle-exclamation tooltip" data-title="Invalid format"></i>' +
                '<a href="https://support.userback.io/en/articles/6102051-getting-started-with-your-feedback-portal-and-configuring-portal-settings" target="help" rel="noopener">Learn more</a>' +
            '</span>' : '') +
        '</div>';

        if (field_example) {
            header += '<div class="example">Example: ' + Util.htmlEntities(field_example) + '</div>';
        }

        return header;
    },

    renderImportButton: function() {
        var import_num = this.first_row_header ? this.data_count - 1 : this.data_count;

        this.$el.find('.import-submit').html('<i class="fa-solid fa-arrow-up-from-bracket margin-right-8"></i>Import ' + import_num + ' idea' + (import_num === 1 ? '' : 's'));
    },

    render: function() {
        var content =
        '<div class="region-upload-step" data-step="1">' +
            '<div class="file-select">' +
                '<div class="icon">' +
                    '<i class="fa-solid fa-file-spreadsheet"></i>' +
                '</div>' +
                '<div class="header">Select a .csv file to upload</div>' +
                '<div class="text-info margin-top-8">or drag and drop it here</div>' +
                '<div class="uploading"><i class="fa-solid fa-spinner-third fa-spin"></i> Uploading file...</div>' +
                '<div class="upload-error"></div>' +
            '</div>' +
        '</div>' +

        '<div class="region-upload-step" data-step="2">' +
            '<div class="region-csv-settings">' +
                '<div class="header-setting">' +
                    '<span class="setting-label v-align-middle margin-right-8">First row is header</span>' +
                    '<button class="first-row-toggle switch-on small v-align-middle" type="button"></button>' +
                '</div>' +

                '<div class="missing-fields"></div>' +

                '<div class="actions">' +
                    '<button class="text medium go-back" type="button"><i class="fa-solid fa-angle-left fa-xs"></i>Back</button>' +
                    '<button class="primary medium import-submit" type="button"></button>' +
                '</div>' +
            '</div>' +
            '<div class="region-csv-preview"></div>' +

            '<div class="csv-upload-mask mask-light"></div>' +
            '<div class="csv-upload-progress">' +
                '<div class="icon"><i class="fa-solid fa-cloud-arrow-up"></i></div>' +
                '<div class="header"></div>' +
                '<div class="meteor-success"><div><span style="width:0%;"></span></div></div>' +
                '<div class="upload-percent"></div>' +
                '<div class="open-portal">' +
                    '<a href="#" class="upload-download primary font-weight-medium"><i class="fa-solid fa-download fa-fw margin-right-4"></i>Download failed records</a>' +
                    '<a href="' + this.model.getUrl() + '" target="_blank" class="primary font-weight-medium"><i class="fa-solid fa-arrow-up-right-from-square margin-right-4"></i>Open ideas portal</a>' +
                '</div>' +
            '</div>' +
        '</div>';

        this.$el.html(content);

        return this;
    }
});